module.exports = __webpack_public_path__ + "img/metro.55ee886e.svg";